import React from 'react'

const Const = {
  ASPECT: Math.sqrt(1.25) + 0.5, // φ

  MESI: [
    'Gennaio',
    'Febbraio',
    'Marzo',
    'Aprile',
    'Maggio',
    'Giugno',
    'Luglio',
    'Agosto',
    'Settembre',
    'Ottobre',
    'Novembre',
    'Dicembre',
  ],

  YELLOW: '#fab232',
  ORANGE: '#f24d20',
  RED: '#e53037',
  BLUE: '#428bca',
  GREEN: '#05d194',
  GREEN_2: '#08c46f',

  AREA_BG: '#e2e7ed',

  AXIS_COLOR: '#444',

  ERRORE: (
    <p>
      Siamo spiacenti, si è verificato un errore.
      <br />
      Si prega di riprovare effettuando una nuova ricerca.
      <br />
      In caso di errori persistenti, contattare il supporto tecnico.
    </p>
  ),
}

export default Const



// WEBPACK FOOTER //
// ./src/Const.js